export default __webpack_public_path__ + "static/media/certs-2.ecc9e165.png";